import axios from "axios"
import { authStore } from "@/store/authStore"

export default {
    async get(url, params = {}) {
        const store = authStore()
        try {
            return await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${store.token}`,
                    'Content-Type': 'application/json'
                },
                params: params
            })
        } catch (e) {
            console.log(e)
        }
    },
    async post(url, params = {}) {
        const store = authStore()
        try {
            return await axios.post(url, params, {
                headers: {
                    'Authorization': `Bearer ${store.token}`,
                    'Content-Type': 'application/json'
                }
            })
        } catch (e) {
            console.log(e)
        }
    }
}